import { createFileRoute } from "@tanstack/react-router";
import ThankYouBenefits from "@/pages/ThankYouBenefits";
export const Route = createFileRoute("/thank-you-benefits")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Thank You — Benefits Check Received | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Thank you for requesting a free benefits check. A member of our team will call you within one business day in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:title",
          content: "Thank You — Benefits Check Received | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Thank you for requesting a free benefits check. A member of our team will call you within one business day in Coral Springs, FL At Neuro Wellness TMS.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you-benefits",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you-benefits",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouBenefits />;
}
